// @flow
import * as React from 'react'
import styled from 'styled-components'
import colors from '../../styles/colors'
import { validationMessages } from '../../utils/validation'

const Message = ({ error, errorMessages, marginTop, id = null, role = null }) => {
  return <StyledMessage selectInputMarginTop={marginTop} id={id} role={role}>
    {(errorMessages && errorMessages[error]) || validationMessages[error]}
  </StyledMessage>;
}

const StyledMessage = styled.div`
  position: absolute;
  font-size: 0.75rem;
  font-weight: bold;
  color: ${colors.monza};
  text-align: left;
  ${({ selectInputMarginTop }) =>
    selectInputMarginTop
      ? `
     margin-top: 45px;
     
  `
      : ``}
`

export default Message
